import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@shopify/polaris";
import PlanCard from "./Plan";
import Home from "./Home";
import HowToUse from "./HowToUse";
import Settings from "./Settings";
import { NavMenu } from "@shopify/app-bridge-react";
import axios from 'axios';


const App = () => {
  return (
    <AppProvider i18n={{}}>
      <BrowserRouter>
      <NavMenu>
        <a href="/settings" rel="home">Settings</a>
        <a href="/plan">Plan</a>
        <a href="/how-to-use">How to use</a>
      </NavMenu>
        <Routes>
          <Route path="/settings" element={<Settings />} />
          <Route path="/plan" element={<PlanCard/>} />
          <Route index path="/" element={<Home />} />
          <Route path="/install" element={<Home />} />
          {/* <Route path="/api/shopify/install" element={<Home />} /> */}
          <Route path="/how-to-use" element={<HowToUse />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
};

export default App;
